/**
 * @generated SignedSource<<2d86b83c874ad0c4637b074c08552dd9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClubRow_MemberProfile$data = {
  readonly club: {
    readonly id: string;
    readonly logoImage: {
      readonly publicId: string;
    } | null | undefined;
    readonly name: string;
    readonly slug: string;
  } | null | undefined;
  readonly hidden: boolean | null | undefined;
  readonly id: string;
  readonly member: {
    readonly id?: string;
  } | null | undefined;
  readonly " $fragmentType": "ClubRow_MemberProfile";
};
export type ClubRow_MemberProfile$key = {
  readonly " $data"?: ClubRow_MemberProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClubRow_MemberProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClubRow_MemberProfile",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hidden",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "logoImage",
          "plural": false,
          "selections": [
            {
              "alias": "publicId",
              "args": null,
              "kind": "ScalarField",
              "name": "renderingKey",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "member",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "Member",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "Customer",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MemberProfile",
  "abstractKey": null
};
})();

(node as any).hash = "a3ca2bac6e68874d1aa8067d80715797";

export default node;
